/* Avé theme — light interactive behaviour */
(function () {
  "use strict";

  /* Mobile nav toggle */
  var header = document.querySelector(".site-header");
  var toggle = document.querySelector(".nav-toggle");
  if (toggle && header) {
    toggle.addEventListener("click", function () {
      header.classList.toggle("nav-open");
    });
  }

  /* FAQ accordion */
  document.querySelectorAll(".faq__item").forEach(function (item) {
    var q = item.querySelector(".faq__q");
    var a = item.querySelector(".faq__a");
    if (!q || !a) return;
    q.addEventListener("click", function () {
      var isOpen = item.classList.contains("open");
      // close siblings within the same list
      var list = item.closest(".faq__list");
      if (list) {
        list.querySelectorAll(".faq__item.open").forEach(function (o) {
          if (o !== item) {
            o.classList.remove("open");
            var oa = o.querySelector(".faq__a");
            if (oa) oa.style.maxHeight = null;
          }
        });
      }
      item.classList.toggle("open");
      a.style.maxHeight = isOpen ? null : a.scrollHeight + "px";
    });
  });

  /* Quantity steppers */
  document.querySelectorAll("[data-qty]").forEach(function (wrap) {
    var input = wrap.querySelector("input");
    wrap.querySelectorAll("button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var step = btn.dataset.step === "up" ? 1 : -1;
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
      });
    });
  });

  /* Scroll reveal */
  var reveals = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && reveals.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    reveals.forEach(function (el) {
      io.observe(el);
    });
  } else {
    reveals.forEach(function (el) {
      el.classList.add("in");
    });
  }
})();
